import axios from "axios";
import {
  SETTINGS_JOBTYPE_CLEAR_SNACKBAR,
  SETTINGS_JOBTYPE_ERROR,
  SETTINGS_DELETE_JOBTYPE_SUCCESS,
  SETTINGS_GET_JOBTYPE_LOADING,
  SETTINGS_ADD_JOBTYPE_ERROR,
  SETTINGS_ADD_JOBTYPE_SUCCESS,
  SETTINGS_ADD_JOBTYPE,
  SETTINGS_GET_JOBTYPE,
  SETTINGS_JOB_STATUS_CLEAR_SNACKBAR,
  SETTINGS_JOB_STATUS_ERROR,
  SETTINGS_DELETE_JOB_STATUS_SUCCESS,
  SETTINGS_GET_JOB_STATUS_LOADING,
  SETTINGS_ADD_JOB_STATUS_ERROR,
  SETTINGS_ADD_JOB_STATUS_SUCCESS,
  SETTINGS_ADD_JOB_STATUS,
  SETTINGS_GET_JOB_STATUS,
} from "../constants/types";
import queryString from "query-string";

// import { bulkUploadFiles } from "./documentsActions";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchJobStatus = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_JOB_STATUS_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/JobStatus`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_JOB_STATUS,
            payload: {
              jobStatus: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_JOB_STATUS_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all JobStatus.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdateJobStatus = ({ formData, onSuccess, payload }) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_JOB_STATUS,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.jobStatusId ? "PUT" : "POST",
        url: `${server_url}/JobStatus${
          formData.jobStatusId ? `/${formData.jobStatusId}` : ""
        }`,
        body: { ...data },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_JOB_STATUS_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.jobStatusId
                ? "JobStatus updated Successfully"
                : "JobStatus Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_JOB_STATUS_ERROR,
            payload: {
              text: "Error occurred during creating jobStatus data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const jobStatusDelete = ({
  jobStatusId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the jobStatusDelete Action", jobStatusId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_JOB_STATUS_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/JobStatus/${jobStatusId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchJobStatus({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_JOB_STATUS_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "jobStatus Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_JOB_STATUS_ERROR,
            payload: {
              text: "Error occurred during deleting job Status data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const jobStatusClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_JOB_STATUS_CLEAR_SNACKBAR,
    });
  };
};
